import React from 'react'
import SuccessAlert from './SuccessAlert'
import WarningAlert from './WarningAlert';
import InformationAlert from './InformationAlert';
import DangerAlert from './DangerAlert';

export const CreateAlert = (message, messageType, updateAlert) => {
  updateAlert({
    message: message,
    messageType: messageType.toString()
  });
  setTimeout(() => {
    updateAlert(null);
  }, 3000);
};

function SKAlerts(props) {
  return (
      props.alert && (
        props.alert.messageType === "Success" ? <SuccessAlert alert={props.alert}></SuccessAlert> : 
        props.alert.messageType === "Warning" ? <WarningAlert alert={props.alert}></WarningAlert> :
        props.alert.messageType === "Error" ? <DangerAlert alert={props.alert}></DangerAlert> :
        props.alert.messageType === "Info" ? <InformationAlert alert={props.alert}></InformationAlert> : 
        null
      )
  )
}

export default SKAlerts